/* eslint-disable promise/avoid-new */
export const getApplicationParagraphNumber = (abstract, claims, description, targetSentence) => {
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('../workers/get-application-paragraph-number-worker.js', import.meta.url));

    worker.onmessage = function(e) {
      resolve(e.data);
      worker.terminate();
    };

    worker.onerror = function(error) {
      reject(error);
      worker.terminate();
    };

    worker.postMessage({ abstract, claims, description, targetSentence });
  });
};
/* eslint-enable promise/avoid-new */
